import { createFileRoute } from '@tanstack/react-router';
import { NewAuditPage } from '@/features/audits/new/new-audit-page';

export const Route = createFileRoute('/_app/w/$workspaceId/audits/new')({
    staticData: {
        crumbs: [{ label: 'shell.audits', to: '/w/$workspaceId/audits' }, { label: 'shell.crumbNewAudit' }],
    },
    component: function NewAuditRoute() {
        const { organizationId, workspaceId } = Route.useRouteContext().workspaceScope;
        return <NewAuditPage organizationId={organizationId} workspaceId={workspaceId} />;
    },
});
